export type RegistrationSearchRow = {
  full_name: string;
  email?: string | null;
  phone?: string | null;
  registration_code: string;
  institution?: string | null;
  country?: string | null;
};

/** Client-side registration search used by Admin → Registrations. */
export function filterRegistrations<T extends RegistrationSearchRow>(
  rows: T[],
  query: string,
): T[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return rows;
  return rows.filter((r) =>
    [r.full_name, r.email, r.phone, r.registration_code, r.institution, r.country]
      .filter(Boolean)
      .some((v) => String(v).toLowerCase().includes(needle)),
  );
}
